import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTodos } from '../api/todosApi';

export function TodoDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [todo, setTodo] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetchTodos().then((data) => {
      if (data.success) {
        const found = data.todos.find((t) => t.id === parseInt(id, 10));
        if (found) {
          setTodo(found);
        } else {
          setNotFound(true);
        }
      }
    });
  }, [id]);

  if (notFound) {
    return (
      <div className="column-flex align-center">
        <p>Todo not found.</p>
        <button type="button" onClick={() => navigate('/todos')}>
          Back
        </button>
      </div>
    );
  }

  if (!todo) {
    return <div className="column-flex align-center">Loading...</div>;
  }

  return (
    <div className="column-flex align-center" style={{ padding: '1rem' }}>
      <button
        type="button"
        onClick={() => navigate('/todos')}
        style={{ alignSelf: 'flex-start' }}
      >
        &larr; Back
      </button>
      <h2>{todo.title}</h2>
      <p>{todo.description || <em>No description</em>}</p>
      <p>Status: {todo.completed ? 'Completed' : 'Pending'}</p>
      <p>Created: {new Date(todo.created_at).toLocaleString()}</p>
    </div>
  );
}
